module.exports = __webpack_public_path__ + "img/discount.b4e6ce5.png";